// source: followPositionMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.FollowPositionPbMsg', null, global)
goog.exportSymbol('proto.FollowPositionPbMsg.FollowCurrentPositionDTO', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowPositionPbMsg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FollowPositionPbMsg.repeatedFields_, null)
}
goog.inherits(proto.FollowPositionPbMsg, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowPositionPbMsg.displayName = 'proto.FollowPositionPbMsg'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.FollowPositionPbMsg.FollowCurrentPositionDTO, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowPositionPbMsg.FollowCurrentPositionDTO.displayName = 'proto.FollowPositionPbMsg.FollowCurrentPositionDTO'
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FollowPositionPbMsg.repeatedFields_ = [4]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowPositionPbMsg.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowPositionPbMsg.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowPositionPbMsg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowPositionPbMsg.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        copytraderid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        copytraderuid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        traderuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
        currentpositionsList: jspb.Message.toObjectList(
          msg.getCurrentpositionsList(),
          proto.FollowPositionPbMsg.FollowCurrentPositionDTO.toObject,
          includeInstance
        ),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowPositionPbMsg}
 */
proto.FollowPositionPbMsg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowPositionPbMsg()
  return proto.FollowPositionPbMsg.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowPositionPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowPositionPbMsg}
 */
proto.FollowPositionPbMsg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCopytraderid(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCopytraderuid(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTraderuid(value)
        break
      case 4:
        var value = new proto.FollowPositionPbMsg.FollowCurrentPositionDTO()
        reader.readMessage(value, proto.FollowPositionPbMsg.FollowCurrentPositionDTO.deserializeBinaryFromReader)
        msg.addCurrentpositions(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowPositionPbMsg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowPositionPbMsg.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowPositionPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowPositionPbMsg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getCopytraderid()
  if (f !== 0) {
    writer.writeInt64(1, f)
  }
  f = message.getCopytraderuid()
  if (f !== 0) {
    writer.writeInt64(2, f)
  }
  f = message.getTraderuid()
  if (f !== 0) {
    writer.writeInt64(3, f)
  }
  f = message.getCurrentpositionsList()
  if (f.length > 0) {
    writer.writeRepeatedMessage(4, f, proto.FollowPositionPbMsg.FollowCurrentPositionDTO.serializeBinaryToWriter)
  }
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowPositionPbMsg.FollowCurrentPositionDTO.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowPositionPbMsg.FollowCurrentPositionDTO.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        closingprofitconditionamount: jspb.Message.getFieldWithDefault(msg, 1, ''),
        closinglossconditionamount: jspb.Message.getFieldWithDefault(msg, 2, ''),
        closingconditionamount: jspb.Message.getFieldWithDefault(msg, 3, ''),
        closingamount: jspb.Message.getFieldWithDefault(msg, 4, ''),
        amount: jspb.Message.getFieldWithDefault(msg, 5, ''),
        orderamount: jspb.Message.getFieldWithDefault(msg, 6, ''),
        ordersize: jspb.Message.getFieldWithDefault(msg, 7, ''),
        orderfee: jspb.Message.getFieldWithDefault(msg, 8, ''),
        ordermargin: jspb.Message.getFieldWithDefault(msg, 9, ''),
        fee: jspb.Message.getFieldWithDefault(msg, 10, ''),
        liqudateprice: jspb.Message.getFieldWithDefault(msg, 11, ''),
        realizedsurplus: jspb.Message.getFieldWithDefault(msg, 12, ''),
        availablebalance: jspb.Message.getFieldWithDefault(msg, 13, ''),
        maintenancemargin: jspb.Message.getFieldWithDefault(msg, 14, ''),
        price: jspb.Message.getFieldWithDefault(msg, 15, ''),
        entirelever: jspb.Message.getFieldWithDefault(msg, 16, ''),
        openmargin: jspb.Message.getFieldWithDefault(msg, 17, ''),
        lever: jspb.Message.getFieldWithDefault(msg, 18, ''),
        partinlever: jspb.Message.getFieldWithDefault(msg, 19, ''),
        size: jspb.Message.getFieldWithDefault(msg, 20, ''),
        brokerprice: jspb.Message.getFieldWithDefault(msg, 21, ''),
        unrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 22, ''),
        createddate: jspb.Message.getFieldWithDefault(msg, 23, 0),
        unitamount: jspb.Message.getFieldWithDefault(msg, 24, ''),
        margindigit: jspb.Message.getFieldWithDefault(msg, 25, 0),
        openmarginrate: jspb.Message.getFieldWithDefault(msg, 26, ''),
        autoaddmargin: jspb.Message.getFieldWithDefault(msg, 27, 0),
        base: jspb.Message.getFieldWithDefault(msg, 28, ''),
        brokerid: jspb.Message.getFieldWithDefault(msg, 29, 0),
        contractcode: jspb.Message.getFieldWithDefault(msg, 30, ''),
        env: jspb.Message.getFieldWithDefault(msg, 31, 0),
        feerate: jspb.Message.getFieldWithDefault(msg, 32, ''),
        id: jspb.Message.getFieldWithDefault(msg, 33, 0),
        maintainrate: jspb.Message.getFieldWithDefault(msg, 34, ''),
        marketpricedigit: jspb.Message.getFieldWithDefault(msg, 35, 0),
        maxlever: jspb.Message.getFieldWithDefault(msg, 36, ''),
        modifydate: jspb.Message.getFieldWithDefault(msg, 37, 0),
        preliqudateprice: jspb.Message.getFieldWithDefault(msg, 38, ''),
        quote: jspb.Message.getFieldWithDefault(msg, 39, ''),
        score: jspb.Message.getFieldWithDefault(msg, 40, 0),
        side: jspb.Message.getFieldWithDefault(msg, 41, ''),
        type: jspb.Message.getFieldWithDefault(msg, 42, 0),
        userid: jspb.Message.getFieldWithDefault(msg, 43, 0),
        indexbase: jspb.Message.getFieldWithDefault(msg, 44, ''),
        maxamount: jspb.Message.getFieldWithDefault(msg, 45, 0),
        risk: jspb.Message.getFieldWithDefault(msg, 46, 0),
        markprice: jspb.Message.getFieldWithDefault(msg, 47, ''),
        lastprice: jspb.Message.getFieldWithDefault(msg, 48, ''),
        basedisplayname: jspb.Message.getFieldWithDefault(msg, 49, ''),
        quotedisplayname: jspb.Message.getFieldWithDefault(msg, 50, ''),
        contractcodedisplayname: jspb.Message.getFieldWithDefault(msg, 51, ''),
        indexbasedisplayname: jspb.Message.getFieldWithDefault(msg, 52, ''),
        dualposition: jspb.Message.getFieldWithDefault(msg, 53, 0),
        dealmarket: jspb.Message.getFieldWithDefault(msg, 54, 0),
        selectedmode: jspb.Message.getFieldWithDefault(msg, 55, 0),
        sort: jspb.Message.getFieldWithDefault(msg, 56, 0),
        donationopenmargin: jspb.Message.getFieldWithDefault(msg, 57, ''),
        donationmaintenancemargin: jspb.Message.getFieldWithDefault(msg, 58, ''),
        donationfee: jspb.Message.getFieldWithDefault(msg, 59, ''),
        donationordermargin: jspb.Message.getFieldWithDefault(msg, 60, ''),
        donationorderfee: jspb.Message.getFieldWithDefault(msg, 61, ''),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowPositionPbMsg.FollowCurrentPositionDTO()
  return proto.FollowPositionPbMsg.FollowCurrentPositionDTO.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setClosingprofitconditionamount(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setClosinglossconditionamount(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setClosingconditionamount(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setClosingamount(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setAmount(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrderamount(value)
        break
      case 7:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrdersize(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrderfee(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrdermargin(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setFee(value)
        break
      case 11:
        var value = /** @type {string} */ (reader.readString())
        msg.setLiqudateprice(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setRealizedsurplus(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setAvailablebalance(value)
        break
      case 14:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaintenancemargin(value)
        break
      case 15:
        var value = /** @type {string} */ (reader.readString())
        msg.setPrice(value)
        break
      case 16:
        var value = /** @type {string} */ (reader.readString())
        msg.setEntirelever(value)
        break
      case 17:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenmargin(value)
        break
      case 18:
        var value = /** @type {string} */ (reader.readString())
        msg.setLever(value)
        break
      case 19:
        var value = /** @type {string} */ (reader.readString())
        msg.setPartinlever(value)
        break
      case 20:
        var value = /** @type {string} */ (reader.readString())
        msg.setSize(value)
        break
      case 21:
        var value = /** @type {string} */ (reader.readString())
        msg.setBrokerprice(value)
        break
      case 22:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnrealizedsurplus(value)
        break
      case 23:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCreateddate(value)
        break
      case 24:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnitamount(value)
        break
      case 25:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMargindigit(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenmarginrate(value)
        break
      case 27:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setAutoaddmargin(value)
        break
      case 28:
        var value = /** @type {string} */ (reader.readString())
        msg.setBase(value)
        break
      case 29:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setBrokerid(value)
        break
      case 30:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcode(value)
        break
      case 31:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setEnv(value)
        break
      case 32:
        var value = /** @type {string} */ (reader.readString())
        msg.setFeerate(value)
        break
      case 33:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setId(value)
        break
      case 34:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaintainrate(value)
        break
      case 35:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMarketpricedigit(value)
        break
      case 36:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaxlever(value)
        break
      case 37:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setModifydate(value)
        break
      case 38:
        var value = /** @type {string} */ (reader.readString())
        msg.setPreliqudateprice(value)
        break
      case 39:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuote(value)
        break
      case 40:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setScore(value)
        break
      case 41:
        var value = /** @type {string} */ (reader.readString())
        msg.setSide(value)
        break
      case 42:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setType(value)
        break
      case 43:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setUserid(value)
        break
      case 44:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbase(value)
        break
      case 45:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMaxamount(value)
        break
      case 46:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setRisk(value)
        break
      case 47:
        var value = /** @type {string} */ (reader.readString())
        msg.setMarkprice(value)
        break
      case 48:
        var value = /** @type {string} */ (reader.readString())
        msg.setLastprice(value)
        break
      case 49:
        var value = /** @type {string} */ (reader.readString())
        msg.setBasedisplayname(value)
        break
      case 50:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuotedisplayname(value)
        break
      case 51:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcodedisplayname(value)
        break
      case 52:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbasedisplayname(value)
        break
      case 53:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDualposition(value)
        break
      case 54:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDealmarket(value)
        break
      case 55:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSelectedmode(value)
        break
      case 56:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSort(value)
        break
      case 57:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationopenmargin(value)
        break
      case 58:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationmaintenancemargin(value)
        break
      case 59:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationfee(value)
        break
      case 60:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationordermargin(value)
        break
      case 61:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationorderfee(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowPositionPbMsg.FollowCurrentPositionDTO.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getClosingprofitconditionamount()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getClosinglossconditionamount()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getClosingconditionamount()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getClosingamount()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getAmount()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getOrderamount()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getOrdersize()
  if (f.length > 0) {
    writer.writeString(7, f)
  }
  f = message.getOrderfee()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getOrdermargin()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getFee()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
  f = message.getLiqudateprice()
  if (f.length > 0) {
    writer.writeString(11, f)
  }
  f = message.getRealizedsurplus()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getAvailablebalance()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getMaintenancemargin()
  if (f.length > 0) {
    writer.writeString(14, f)
  }
  f = message.getPrice()
  if (f.length > 0) {
    writer.writeString(15, f)
  }
  f = message.getEntirelever()
  if (f.length > 0) {
    writer.writeString(16, f)
  }
  f = message.getOpenmargin()
  if (f.length > 0) {
    writer.writeString(17, f)
  }
  f = message.getLever()
  if (f.length > 0) {
    writer.writeString(18, f)
  }
  f = message.getPartinlever()
  if (f.length > 0) {
    writer.writeString(19, f)
  }
  f = message.getSize()
  if (f.length > 0) {
    writer.writeString(20, f)
  }
  f = message.getBrokerprice()
  if (f.length > 0) {
    writer.writeString(21, f)
  }
  f = message.getUnrealizedsurplus()
  if (f.length > 0) {
    writer.writeString(22, f)
  }
  f = message.getCreateddate()
  if (f !== 0) {
    writer.writeInt64(23, f)
  }
  f = message.getUnitamount()
  if (f.length > 0) {
    writer.writeString(24, f)
  }
  f = message.getMargindigit()
  if (f !== 0) {
    writer.writeInt32(25, f)
  }
  f = message.getOpenmarginrate()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getAutoaddmargin()
  if (f !== 0) {
    writer.writeInt32(27, f)
  }
  f = message.getBase()
  if (f.length > 0) {
    writer.writeString(28, f)
  }
  f = message.getBrokerid()
  if (f !== 0) {
    writer.writeInt32(29, f)
  }
  f = message.getContractcode()
  if (f.length > 0) {
    writer.writeString(30, f)
  }
  f = message.getEnv()
  if (f !== 0) {
    writer.writeInt32(31, f)
  }
  f = message.getFeerate()
  if (f.length > 0) {
    writer.writeString(32, f)
  }
  f = message.getId()
  if (f !== 0) {
    writer.writeInt64(33, f)
  }
  f = message.getMaintainrate()
  if (f.length > 0) {
    writer.writeString(34, f)
  }
  f = message.getMarketpricedigit()
  if (f !== 0) {
    writer.writeInt32(35, f)
  }
  f = message.getMaxlever()
  if (f.length > 0) {
    writer.writeString(36, f)
  }
  f = message.getModifydate()
  if (f !== 0) {
    writer.writeInt64(37, f)
  }
  f = message.getPreliqudateprice()
  if (f.length > 0) {
    writer.writeString(38, f)
  }
  f = message.getQuote()
  if (f.length > 0) {
    writer.writeString(39, f)
  }
  f = message.getScore()
  if (f !== 0) {
    writer.writeInt32(40, f)
  }
  f = message.getSide()
  if (f.length > 0) {
    writer.writeString(41, f)
  }
  f = message.getType()
  if (f !== 0) {
    writer.writeInt32(42, f)
  }
  f = message.getUserid()
  if (f !== 0) {
    writer.writeInt64(43, f)
  }
  f = message.getIndexbase()
  if (f.length > 0) {
    writer.writeString(44, f)
  }
  f = message.getMaxamount()
  if (f !== 0) {
    writer.writeInt32(45, f)
  }
  f = message.getRisk()
  if (f !== 0) {
    writer.writeInt32(46, f)
  }
  f = message.getMarkprice()
  if (f.length > 0) {
    writer.writeString(47, f)
  }
  f = message.getLastprice()
  if (f.length > 0) {
    writer.writeString(48, f)
  }
  f = message.getBasedisplayname()
  if (f.length > 0) {
    writer.writeString(49, f)
  }
  f = message.getQuotedisplayname()
  if (f.length > 0) {
    writer.writeString(50, f)
  }
  f = message.getContractcodedisplayname()
  if (f.length > 0) {
    writer.writeString(51, f)
  }
  f = message.getIndexbasedisplayname()
  if (f.length > 0) {
    writer.writeString(52, f)
  }
  f = message.getDualposition()
  if (f !== 0) {
    writer.writeInt32(53, f)
  }
  f = message.getDealmarket()
  if (f !== 0) {
    writer.writeInt32(54, f)
  }
  f = message.getSelectedmode()
  if (f !== 0) {
    writer.writeInt32(55, f)
  }
  f = message.getSort()
  if (f !== 0) {
    writer.writeInt32(56, f)
  }
  f = message.getDonationopenmargin()
  if (f.length > 0) {
    writer.writeString(57, f)
  }
  f = message.getDonationmaintenancemargin()
  if (f.length > 0) {
    writer.writeString(58, f)
  }
  f = message.getDonationfee()
  if (f.length > 0) {
    writer.writeString(59, f)
  }
  f = message.getDonationordermargin()
  if (f.length > 0) {
    writer.writeString(60, f)
  }
  f = message.getDonationorderfee()
  if (f.length > 0) {
    writer.writeString(61, f)
  }
}

/**
 * optional string closingProfitConditionAmount = 1;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getClosingprofitconditionamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setClosingprofitconditionamount = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string closingLossConditionAmount = 2;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getClosinglossconditionamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setClosinglossconditionamount = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string closingConditionAmount = 3;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getClosingconditionamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setClosingconditionamount = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string closingAmount = 4;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getClosingamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setClosingamount = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string amount = 5;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string orderAmount = 6;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOrderamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOrderamount = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional string orderSize = 7;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOrdersize = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOrdersize = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value)
}

/**
 * optional string orderFee = 8;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOrderfee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOrderfee = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string orderMargin = 9;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOrdermargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOrdermargin = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional string fee = 10;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getFee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setFee = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional string liqudatePrice = 11;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getLiqudateprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setLiqudateprice = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value)
}

/**
 * optional string realizedSurplus = 12;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getRealizedsurplus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setRealizedsurplus = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string availableBalance = 13;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getAvailablebalance = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setAvailablebalance = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional string maintenanceMargin = 14;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMaintenancemargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMaintenancemargin = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value)
}

/**
 * optional string price = 15;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value)
}

/**
 * optional string entireLever = 16;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getEntirelever = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setEntirelever = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value)
}

/**
 * optional string openMargin = 17;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOpenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOpenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value)
}

/**
 * optional string lever = 18;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getLever = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setLever = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value)
}

/**
 * optional string partInLever = 19;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getPartinlever = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setPartinlever = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value)
}

/**
 * optional string size = 20;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getSize = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setSize = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value)
}

/**
 * optional string brokerPrice = 21;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getBrokerprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setBrokerprice = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value)
}

/**
 * optional string unRealizedSurplus = 22;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getUnrealizedsurplus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setUnrealizedsurplus = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value)
}

/**
 * optional int64 createdDate = 23;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getCreateddate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setCreateddate = function (value) {
  return jspb.Message.setProto3IntField(this, 23, value)
}

/**
 * optional string unitAmount = 24;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getUnitamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setUnitamount = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value)
}

/**
 * optional int32 marginDigit = 25;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMargindigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMargindigit = function (value) {
  return jspb.Message.setProto3IntField(this, 25, value)
}

/**
 * optional string openMarginRate = 26;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getOpenmarginrate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setOpenmarginrate = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional int32 autoAddMargin = 27;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getAutoaddmargin = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setAutoaddmargin = function (value) {
  return jspb.Message.setProto3IntField(this, 27, value)
}

/**
 * optional string base = 28;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getBase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setBase = function (value) {
  return jspb.Message.setProto3StringField(this, 28, value)
}

/**
 * optional int32 brokerId = 29;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getBrokerid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setBrokerid = function (value) {
  return jspb.Message.setProto3IntField(this, 29, value)
}

/**
 * optional string contractCode = 30;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getContractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setContractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 30, value)
}

/**
 * optional int32 env = 31;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getEnv = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setEnv = function (value) {
  return jspb.Message.setProto3IntField(this, 31, value)
}

/**
 * optional string feeRate = 32;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getFeerate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setFeerate = function (value) {
  return jspb.Message.setProto3StringField(this, 32, value)
}

/**
 * optional int64 id = 33;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 33, value)
}

/**
 * optional string maintainRate = 34;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMaintainrate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMaintainrate = function (value) {
  return jspb.Message.setProto3StringField(this, 34, value)
}

/**
 * optional int32 marketPriceDigit = 35;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMarketpricedigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMarketpricedigit = function (value) {
  return jspb.Message.setProto3IntField(this, 35, value)
}

/**
 * optional string maxLever = 36;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMaxlever = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMaxlever = function (value) {
  return jspb.Message.setProto3StringField(this, 36, value)
}

/**
 * optional int64 modifyDate = 37;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getModifydate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setModifydate = function (value) {
  return jspb.Message.setProto3IntField(this, 37, value)
}

/**
 * optional string preLiqudatePrice = 38;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getPreliqudateprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setPreliqudateprice = function (value) {
  return jspb.Message.setProto3StringField(this, 38, value)
}

/**
 * optional string quote = 39;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getQuote = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setQuote = function (value) {
  return jspb.Message.setProto3StringField(this, 39, value)
}

/**
 * optional int32 score = 40;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getScore = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setScore = function (value) {
  return jspb.Message.setProto3IntField(this, 40, value)
}

/**
 * optional string side = 41;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getSide = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setSide = function (value) {
  return jspb.Message.setProto3StringField(this, 41, value)
}

/**
 * optional int32 type = 42;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setType = function (value) {
  return jspb.Message.setProto3IntField(this, 42, value)
}

/**
 * optional int64 userId = 43;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setUserid = function (value) {
  return jspb.Message.setProto3IntField(this, 43, value)
}

/**
 * optional string indexBase = 44;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getIndexbase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setIndexbase = function (value) {
  return jspb.Message.setProto3StringField(this, 44, value)
}

/**
 * optional int32 maxAmount = 45;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMaxamount = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMaxamount = function (value) {
  return jspb.Message.setProto3IntField(this, 45, value)
}

/**
 * optional int32 risk = 46;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getRisk = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setRisk = function (value) {
  return jspb.Message.setProto3IntField(this, 46, value)
}

/**
 * optional string markPrice = 47;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getMarkprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setMarkprice = function (value) {
  return jspb.Message.setProto3StringField(this, 47, value)
}

/**
 * optional string lastPrice = 48;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getLastprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setLastprice = function (value) {
  return jspb.Message.setProto3StringField(this, 48, value)
}

/**
 * optional string baseDisplayName = 49;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getBasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setBasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 49, value)
}

/**
 * optional string quoteDisplayName = 50;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getQuotedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setQuotedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 50, value)
}

/**
 * optional string contractCodeDisplayName = 51;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getContractcodedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setContractcodedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 51, value)
}

/**
 * optional string indexBaseDisplayName = 52;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getIndexbasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setIndexbasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 52, value)
}

/**
 * optional int32 dualPosition = 53;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDualposition = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 53, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDualposition = function (value) {
  return jspb.Message.setProto3IntField(this, 53, value)
}

/**
 * optional int32 dealMarket = 54;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDealmarket = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 54, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDealmarket = function (value) {
  return jspb.Message.setProto3IntField(this, 54, value)
}

/**
 * optional int32 selectedMode = 55;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getSelectedmode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setSelectedmode = function (value) {
  return jspb.Message.setProto3IntField(this, 55, value)
}

/**
 * optional int32 sort = 56;
 * @return {number}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getSort = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 56, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setSort = function (value) {
  return jspb.Message.setProto3IntField(this, 56, value)
}

/**
 * optional string donationOpenMargin = 57;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDonationopenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDonationopenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 57, value)
}

/**
 * optional string donationMaintenanceMargin = 58;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDonationmaintenancemargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDonationmaintenancemargin = function (value) {
  return jspb.Message.setProto3StringField(this, 58, value)
}

/**
 * optional string donationFee = 59;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDonationfee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 59, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDonationfee = function (value) {
  return jspb.Message.setProto3StringField(this, 59, value)
}

/**
 * optional string donationOrderMargin = 60;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDonationordermargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDonationordermargin = function (value) {
  return jspb.Message.setProto3StringField(this, 60, value)
}

/**
 * optional string donationOrderFee = 61;
 * @return {string}
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.getDonationorderfee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO} returns this
 */
proto.FollowPositionPbMsg.FollowCurrentPositionDTO.prototype.setDonationorderfee = function (value) {
  return jspb.Message.setProto3StringField(this, 61, value)
}

/**
 * optional int64 copyTraderId = 1;
 * @return {number}
 */
proto.FollowPositionPbMsg.prototype.getCopytraderid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg} returns this
 */
proto.FollowPositionPbMsg.prototype.setCopytraderid = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional int64 copyTraderUid = 2;
 * @return {number}
 */
proto.FollowPositionPbMsg.prototype.getCopytraderuid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg} returns this
 */
proto.FollowPositionPbMsg.prototype.setCopytraderuid = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional int64 traderUid = 3;
 * @return {number}
 */
proto.FollowPositionPbMsg.prototype.getTraderuid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowPositionPbMsg} returns this
 */
proto.FollowPositionPbMsg.prototype.setTraderuid = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value)
}

/**
 * repeated FollowCurrentPositionDTO currentPositions = 4;
 * @return {!Array<!proto.FollowPositionPbMsg.FollowCurrentPositionDTO>}
 */
proto.FollowPositionPbMsg.prototype.getCurrentpositionsList = function () {
  return /** @type{!Array<!proto.FollowPositionPbMsg.FollowCurrentPositionDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FollowPositionPbMsg.FollowCurrentPositionDTO, 4)
  )
}

/**
 * @param {!Array<!proto.FollowPositionPbMsg.FollowCurrentPositionDTO>} value
 * @return {!proto.FollowPositionPbMsg} returns this
 */
proto.FollowPositionPbMsg.prototype.setCurrentpositionsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value)
}

/**
 * @param {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FollowPositionPbMsg.FollowCurrentPositionDTO}
 */
proto.FollowPositionPbMsg.prototype.addCurrentpositions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    4,
    opt_value,
    proto.FollowPositionPbMsg.FollowCurrentPositionDTO,
    opt_index
  )
}

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FollowPositionPbMsg} returns this
 */
proto.FollowPositionPbMsg.prototype.clearCurrentpositionsList = function () {
  return this.setCurrentpositionsList([])
}

goog.object.extend(exports, proto)
